import state from './moduleTokenStatusState.js'
import mutations from './moduleTokenStatusMutations.js'
import actions from './moduleTokenStatusActions.js'
import getters from './moduleTokenStatusGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
